import React from 'react';
import { Box, Button, styled, Typography } from '@mui/material';
import { usePopupContext } from '../../PopupContext';

const PopupBox = styled('div')({
  position: 'fixed',
  top: '50%',
  left: '40%',
  zIndex: 99,
  backgroundColor: 'rgba(255, 255, 255, 0.98)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  transform: 'translateY(-50%)', // Center vertically
});

const PopupInner = styled('div')({
  position: 'relative',
  padding: '16px',
  maxWidth: '320px',
  borderRadius: '10px',
  boxShadow: '2px 3px 5px #999',
});

const ButtonStyled = styled(Button)({
  borderRadius: '24px',
  padding: '6px 50px',
});

const ButtonContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'space-around',
  marginTop: '20px',
});

export interface PopupProps {
  children: React.ReactNode;
}

export interface InitalPopupProps {
  initialTrigger: boolean | undefined;
}

const Popup = (props: InitalPopupProps): JSX.Element => {
  const {
    trigger,
    setTrigger,
    message,
    title,
    action,
    method,
    pk,
    sk,
    setExecuteMethod,
  } = usePopupContext();

  return props.initialTrigger || trigger ? (
    <PopupBox data-testid="popup">
      <PopupInner>
        <Typography variant="body1"><b>{title}</b></Typography>
        <hr/>
        <Typography variant="body2">{message}</Typography>
        <ButtonContainer>
          <ButtonStyled
            data-testid="popup-cancel-button"
            variant="outlined"
            onClick={() => {
              setTrigger(false);
            }}
          >
            Cancel
          </ButtonStyled>
          &nbsp;
          <ButtonStyled
            data-testid="popup-action-button"
            variant="contained"
            onClick={() => {
              setExecuteMethod(`${pk}-${sk}-${method}`);
              setTrigger(false);
            }}
          >
            {action}
          </ButtonStyled>
        </ButtonContainer>
      </PopupInner>
    </PopupBox>
  ) : (
    <></>
  );
};

export default Popup;
